import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import CreditMemoRequestService from '../../../../Services/CreditMemo/CreditMemoRequestService';
import ErrorMessage from '../../../ErrorMessage';

export default class CreditMemoRequestInvoiceSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    CreditMemoRequestService.GetClientInvoiceForCreditMemoRequest(this.props.idFilter)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.ciBtname > b.ciBtname ? 1 : -1))
          .forEach((invoice, index) => {
            optValues.push({ label: `${invoice.ciId} - ${invoice.ciBtname}`, value: invoice.ciId, disabled: false });
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('CMRIS51');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
